const getNonEmptyString = (value: unknown): string | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }
  return value.trim() || undefined;
};

export async function getHttpErrorMessage(
  error: any,
  fallback = 'unknown error'
): Promise<string> {
  let responseBody = error?.error;

  if (responseBody instanceof Blob) {
    try {
      responseBody = JSON.parse(await responseBody.text());
    } catch {
      // Fall through to the HttpErrorResponse message or the supplied fallback.
    }
  }

  return (
    getNonEmptyString(responseBody?.message) ??
    getNonEmptyString(responseBody) ??
    getNonEmptyString(error?.message) ??
    fallback
  );
}
